import { withTheme } from 'emotion-theming'
import styled from '@emotion/styled'
import PropTypes from 'prop-types'

import style from './BoatDescription.style'

const BoatDescriptionStyled = styled.div(props => ({ ...style(props) }))

const BoatDescription = ({ title, children }) => {
    return (
        <BoatDescriptionStyled>
            <h3 className="Title">{title}</h3>
            {children && <div className="Content">{children}</div>}
        </BoatDescriptionStyled>
    )
}

BoatDescription.propTypes = {
    title: PropTypes.string.isRequired,
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
}

BoatDescription.defaultProps = {
    children: undefined
}

export default withTheme(BoatDescription)
